export class NumberStepper {
  private readonly el: HTMLElement;
  private readonly input: HTMLInputElement;
  private readonly minus: HTMLButtonElement;
  private readonly plus: HTMLButtonElement;
  private readonly step: number;
  private readonly min: number;
  private readonly max: number;

  constructor(el: HTMLElement) {
    this.el    = el;
    this.input = el.querySelector<HTMLInputElement>(".admin-number-stepper__input")!;
    this.minus = el.querySelector<HTMLButtonElement>(".admin-number-stepper__btn--minus")!;
    this.plus  = el.querySelector<HTMLButtonElement>(".admin-number-stepper__btn--plus")!;

    this.step = parseFloat(el.dataset.step ?? "1") || 1;
    this.min  = el.dataset.min !== undefined ? parseFloat(el.dataset.min) : -Infinity;
    this.max  = el.dataset.max !== undefined ? parseFloat(el.dataset.max) :  Infinity;

    el.dataset.stepperInited = "1";
    this.minus.addEventListener("click", () => this.update(-this.step));
    this.plus.addEventListener("click",  () => this.update(+this.step));
    this.input.addEventListener("input", () => this.syncSize());
    this.syncButtons(this.getValue());
    this.syncSize();
  }

  getValue(): number {
    return parseFloat(this.input.value) || 0;
  }

  setValue(v: number): void {
    const clamped = Math.min(this.max, Math.max(this.min, v));
    this.input.value = String(clamped);
    this.input.dispatchEvent(new Event("input",  { bubbles: true }));
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
    this.syncButtons(clamped);
    this.syncSize();
  }

  private syncSize(): void {
    const len = this.input.value.length || 1;
    this.input.size = Math.max(5, len);
  }

  private update(delta: number): void {
    this.setValue(this.getValue() + delta);
  }

  private syncButtons(v: number): void {
    this.minus.disabled = v <= this.min;
    this.plus.disabled  = v >= this.max;
  }

  static initAll(root: ParentNode = document): void {
    root
      .querySelectorAll<HTMLElement>("[data-number-stepper]:not([data-stepper-inited])")
      .forEach(el => new NumberStepper(el));
  }
}
